export const footerObj = {
  "www.gf-ysc.com": {
    code: "粤ICP备17041355号",
    company: "广州市广农数链信息科技有限公司",
    simple: "广农数链"
  },
  "www.xn--8mrx6wrcq11i90q.com": {
    code: "粤ICP备17041355号",
    company: "广州市广农数链信息科技有限公司",
    simple: "广农数链"
  },
  "www.xn--swt9b.net": {
    code: "粤ICP备17041355号",
    company: "广州市广农数链信息科技有限公司",
    simple: "广农数链"
  },
  "www.xn--j7qy72a.com": {
    code: "粤ICP备17041355号",
    company: "广州市广农数链信息科技有限公司",
    simple: "广农数链"
  },
  "www.tevv.com.cn": {
    code: "粤ICP备17041355号",
    company: "广州市广农数链信息科技有限公司",
    simple: "广农数链"
  },
  "www.oivv.com.cn": {
    code: "粤ICP备17041355号",
    company: "广州市广农数链信息科技有限公司",
    simple: "广农数链"
  },
  "www.xn--8mrx6wrcq11i90q.net": {
    code: "粤ICP备17041355号",
    company: "广州市广农数链信息科技有限公司",
    simple: "广农数链"
  },
  "www.xn--j7qy72a.net": {
    code: "粤ICP备17041355号",
    company: "广州市广农数链信息科技有限公司",
    simple: "广农数链"
  },
  "www.xn--pbto81e.com": {
    code: "粤ICP备18103625号",
    company: "广府数字（深圳）股份有限公司",
    simple: "广府数字"
  },
  "www.balsure.com": {
    code: "粤ICP备18103625号",
    company: "广府数字（深圳）股份有限公司",
    simple: "广府数字"
  },
  "www.baocheng-ip.com": {
    code: "粤ICP备18103625号",
    company: "广府数字（深圳）股份有限公司",
    simple: "广府数字"
  },
  "www.lscq9901.com": {
    code: "粤ICP备18000843号",
    company: "广州市绿色传奇科技有限公司",
    simple: "绿色传奇"
  },
  "localhost": {
    code: "粤ICP备17041355号",
    company: "广州市广农数链信息科技有限公司",
    simple: "广农数链"
  }
};



// WEBPACK FOOTER //
// ./src/assets/config.js